import axios from '../../app/api/axios';
import {
    NEWS_DETAILS_REQUEST,
    NEWS_DETAILS_SUCCESS,
    NEWS_DETAILS_FAILURE,
    NEWS_LIST_REQUEST,
    NEWS_LIST_SUCCESS,
    NEWS_LIST_FAILURE,
} from './types';

export const getNewsList = (page = 1, newSearch = false) => dispatch => {
    dispatch(setNewsListLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('agep/v1/news', {
            page: page,
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: NEWS_LIST_SUCCESS,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime,
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: NEWS_LIST_FAILURE,
                payload: null
            })
        );
};

export const getOtherNewsInList = () => dispatch => {

};

export const getNewsDetails = (slug) => dispatch => {
    dispatch(setNewsDetailsLoading());

    axios
        .get('agep/v1/news/' + slug)
        .then(res =>
            dispatch({
                type: NEWS_DETAILS_SUCCESS,
                payload: res.data
            })
        )
        .catch(function (err) {
            let redirect = '';

            if (err.response.status === 303 && err.response.data.hasOwnProperty('redirect')) {
                redirect = err.response.data.redirect;
            }

            dispatch({
                type: NEWS_DETAILS_FAILURE,
                payload: {
                    status: err.response.status,
                    redirect: redirect,
                }
            });
        });
};

export const setNewsListLoading = () => {
    return {
        type: NEWS_LIST_REQUEST
    };
};

export const setNewsDetailsLoading = () => {
    return {
        type: NEWS_DETAILS_REQUEST
    };
};



// WEBPACK FOOTER //
// ./src/features/News/actions.js